import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  FormControl,
  Grid,
  IconButton,
  makeStyles,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";
import Search from "../grnReceipts/Search";
import CachedIcon from "@material-ui/icons/Cached";
import moment from "moment";
import clsx from "clsx";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import {
  ChevronLeft,
  ChevronRight,
  KeyboardArrowDown,
  KeyboardArrowUp,
} from "@material-ui/icons";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchProjects } from "../../../containers/actions/common/projectActions";
import EditIcon from "@material-ui/icons/Edit";
import { Pagination } from "@material-ui/lab";
import {
  ALL_PROJECTS_TABLE,
  FETCH_PENDING_DELIVERABLES,
  REMIND_PENDING_DELIVERABLE,
} from "../../../containers/actions/types";
import { presentFormatedData } from "../functionalComponents/dataFormatFunctions";
import AutorenewIcon from "@material-ui/icons/Autorenew";
import { remindPendingDeliverable } from "../../../containers/actions/common/projectActions";
import { fetchPendingDeliverables } from "../../../containers/actions/common/projectActions";
import PaginationInput from "../models/pagination/PaginationInput";
import BackDropLoading from "../models/BackDrop";
import usePrevious from "../../../helpers/previousProps";
import { appUrl } from "../../../../../utils/config";

const useStyles = makeStyles((theme) => ({
  refreshContainerSty: {
    display: "flex",
    justifyContent: "flex-end",
    [theme.breakpoints.down("sm")]: {
      justifyContent: "flex-start",
      paddingTop: "1rem",
    },
    [theme.breakpoints.down("xs")]: {
      paddingTop: "1rem",
    },
  },
  refreshSty: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  padR20: {
    paddingRight: 20,
    [theme.breakpoints.down("xs")]: {
      paddingRight: 0,
    },
  },
  hgText: {
    fontWeight: 500,
    paddingRight: theme.spacing(1),
  },
  outlined: {
    padding: theme.spacing(1),
  },
  formControl: {
    minWidth: 120,
    fontSize: "0.875rem",
  },
  formPerPage: {
    minWidth: 60,
    fontSize: "0.875rem",
  },
  upload: {
    background:
      "transparent linear-gradient(251deg, #173072 0%, #301232 100%) 0% 0% no-repeat padding-box;",
    color: "white",
    textTransform: "none",
    borderRadius: "2rem",
    // marginRight: 20,
    padding: "5px 20px",
    "&:hover": {
      backgroundColor: "green",
      background: "green",
      color: "white",
    },
  },
  multipleLogo: {
    border: "1px solid #7d7c7c",
    borderRadius: "4px",
    padding: "0.3rem",
    height: "inherit",
    marginLeft: "0.5rem",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "black",
      color: "white",
      border: "1px solid #FFF",
    },
  },
  clickableTextSty: {
    "&:hover": {
      textDecoration: "underline",
      color: "#2196F3",
      cursor: "pointer",
    },
  },
  dialogContent: {
    textAlign: "center",
    padding: "24px 36px 24px 36px",
  },
  avatar: {
    color: "green",
    margin: "0 auto",
    fontSize: "54px",
  },
  dialogActions: {
    justifyContent: "center",
    marginTop: theme.spacing(2),
  },
}));

const PendingDashboard = () => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const [searchQuery, searchQueryInput] = useState("");
  const [tempSearch, tempSearchQury] = useState("");
  const [noRowsPerPage, setRowsPerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  const [error, setError] = useState("");
  const [remindScreen, setRemindScreen] = useState(false);
  const [openRemindDialog, setOpenRemindDialog] = useState(false);
  let loading = true;

  const [remindPendingData, setRemindPendingData] = useState({});
  const [remindPendingError, setRemindPendingError] = useState(false);
  const didMountRef = useRef(false);

  const remindPendingDetails = useSelector((state) =>
    state.pcmp.common.Projects?.remindPendingDeliverable
      ? state.pcmp.common.Projects?.remindPendingDeliverable
      : {}
  );
  const prevRemindPendingDetails = usePrevious(remindPendingDetails);

  useEffect(() => {
    if (didMountRef.current) {
      if (
        JSON.stringify(remindPendingDetails) !==
        JSON.stringify(prevRemindPendingDetails)
      ) {
        if (remindPendingDetails.status === true) {
          // setLoading(false);
          setRemindPendingError(false);
          setRemindPendingData(remindPendingDetails);
          setOpenRemindDialog(true);
        } else  if (remindPendingDetails.status === false) {
          // setLoading(false);
          setRemindPendingError(true);
          setRemindPendingData(remindPendingDetails);
          setOpenRemindDialog(true);
        }
      }
    } else {
      didMountRef.current = true;
    }
  }, [remindPendingDetails, prevRemindPendingDetails]);

  const pendingDeliverablesList = useSelector((state) => {
    if (state.pcmp.common.Projects?.pendingDeliverables?.status === true) {
      if (loading) {
        loading = false;
      }
      return state.pcmp.common.Projects.pendingDeliverables?.data;
    } else if (
      state.pcmp.common.Projects?.pendingDeliverables?.status === false
    ) {
      if (loading) {
        loading = false;
      }
      if (error === "") {
        setError("Something went wrong. Please try again later.");
      }
    } else {
      return [];
    }
  });

  useEffect(() => {
    dispatch(fetchPendingDeliverables());
  }, [dispatch]);

  const handleOpenRemind = (row) => {
    // setOpenRemindDialog(true);
    const data = {
      projectName: row.projectName,
      organizationName: row.orgName,
      departmentName: row.departmentName,
      pendingDeliverable: row.deliverableDescription,
      pendingDays: row.pendingDays,
      pointOfContactEmailAddress: row.pointOfContactEmailAddress,
      ecosystemUrl:appUrl,
    };
    dispatch(remindPendingDeliverable(data));
  };

  const handleCloseRemind = () => {
    dispatch({
      type:REMIND_PENDING_DELIVERABLE,
      value: {},
    });
    setOpenRemindDialog(false);
  };
  const handleRefresh = () => {
    dispatch({
      type: FETCH_PENDING_DELIVERABLES,
      payload: undefined,
    });
    setError("");
    loading = true;
    dispatch(fetchPendingDeliverables());
  };

  const handleSearchQuery = (event) => {
    let { value } = event.target;
    // if (value === '' || value === null) {
    //   tempSearchQury(value);
    //   searchQueryInput('');
    // } else {
    //   tempSearchQury(value);
    // }
  };

  const handleClearSearch = (event) => {
    event.preventDefault();
    tempSearchQury("");
    searchQueryInput("");
  };

  const submitSearch = (event) => {
    event.preventDefault();
    searchQueryInput(tempSearch.trim());
  };

  const handleSetRows = (event) => {
    setRowsPerPage(event.target.value);
    setCurrentPage(1);
  };

  const pendingTable = pendingDeliverablesList;

  let totalPages = Math.ceil(pendingTable.length / noRowsPerPage);

  let records = currentPage * noRowsPerPage;

  const pendingList = pendingTable
    ? pendingTable.slice(records - noRowsPerPage, records)
    : [];

  const handlePageChange = (data) => {
    setCurrentPage(data);
  };

  return (
    <>
      <React.Fragment>
        <BackDropLoading />
        <Grid
          container
          alignItems="center"
          style={{ paddingBottom: "0.5rem", paddingTop: "1rem" }}
        >
          <Grid item xs={12} sm={10} md={6}>
            <Typography variant="body2" style={{ fontWeight: 500 }}>
              Filter By:
            </Typography>
            <Search
              searchQuery={tempSearch}
              handleSearchQuery={handleSearchQuery}
              handleClearSearch={handleClearSearch}
              submitSearch={submitSearch}
              placeholder={"Search using Compound ID,Type of Batch"}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Grid container className={classes.refreshContainerSty}>
              <Typography variant="caption" className={clsx(classes.padR20)}>
                {`Last synced @ ${moment(new Date()).format(
                  "HH:mm:ss; DD MMMM, YYYY"
                )}`}
              </Typography>

              <Typography
                variant="caption"
                color="primary"
                className={classes.refreshSty}
                onClick={handleRefresh}
              >
                Refresh
                <CachedIcon color="primary" style={{ fontSize: 15 }} />
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid container alignItems="center" justifyContent="flex-end">
          <Grid item>
            <Typography variant="body2" className={classes.hgText}>
              PER PAGE
            </Typography>
            <FormControl className={classes.formPerPage}>
              <Select
                labelId="perpage-filter"
                id="perpage-filter-id"
                value={noRowsPerPage}
                variant="outlined"
                onChange={handleSetRows}
                classes={{
                  outlined: classes.outlined,
                }}
              >
                <MenuItem value={3}>3</MenuItem>
                <MenuItem value={5}>5</MenuItem>
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={15}>15</MenuItem>
                <MenuItem value={30}>30</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
        <TableContainer component={Paper} style={{ marginTop: 20 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align="left">Compound ID</TableCell>
                <TableCell align="left">Organization - Department</TableCell>
                <TableCell align="left">Point of Contact</TableCell>
                <TableCell align="left">Pending Deliverables</TableCell>
                <TableCell align="right">Pending Duration (Days)</TableCell>
                <TableCell align="center">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading === true && (
                <TableRow style={{ height: 150 }}>
                  <TableCell colSpan={6}>
                    <div style={{ textAlign: "center" }}>
                      <CircularProgress color="primary" />
                    </div>
                  </TableCell>
                </TableRow>
              )}
              {loading === false &&
                error === "" &&
                (pendingList.length > 0 ? (
                  pendingList.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell align="left">{row.projectName}</TableCell>
                      <TableCell align="left">
                        {" "}
                        {row.orgName}{" - "}{row.departmentName}
                      </TableCell>
                      <TableCell align="left">
                        {row.pointOfContactName}
                      </TableCell>
                      <TableCell align="left">
                        {row.deliverableDescription}
                      </TableCell>
                      <TableCell align="right">{row.pendingDays}</TableCell>
                      <TableCell align="center">
                        <Button
                          variant="outlined"
                          onClick={() => handleOpenRemind(row)}
                          style={{ textTransform: "none", fontWeight: "400" }}
                        >
                          <AutorenewIcon style={{ fontWeight: "400" }} />
                          Remind
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={6} align="center">
                      No Records Found
                    </TableCell>
                  </TableRow>
                ))}
              {loading === false && error !== "" && (
                <TableRow
                  style={{
                    border: "2px solid #FF0000",
                    backgroundColor: "#FFF0F0",
                  }}
                >
                  <TableCell colSpan={6} align="center">
                    Something went wrong. Please try again later.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <Grid
          container
          alignItems="center"
          justifyContent="center"
          style={{ paddingTop: "1rem" }}
        >
          <PaginationInput
            totalPages={totalPages}
            handlePageChange={handlePageChange}
            page={currentPage}
          />
        </Grid>
      </React.Fragment>

{openRemindDialog &&(
    <Dialog open={openRemindDialog} maxWidth='sm' fullWidth>
        <DialogContent className={classes.dialogContent}>
        {remindPendingDetails.status === false ? (
          <>
          <Typography variant='h6' align="center" style={{fontSize:'0.8rem',paddingTop:'0.5rem',paddingBottom:'0.5rem',marginTop: '7px',color: '#FF0000', border: "2px solid #FF0000", backgroundColor: "#FFF0F0"}}>
            Something Went Wrong. Please contact Schrocken support.
          </Typography>
                    <DialogActions className={classes.dialogActions}>
                    <Button
                      variant='contained'
                      color='primary'
                      endIcon={<ChevronRight />}
                      style={{
                        borderRadius: '20px',
                        textTransform: 'none',
                      }}
                      onClick={handleCloseRemind}
                    >
                      Ok
                    </Button>
                  </DialogActions>
                </>
        ) : (
          <>
          <CheckCircleIcon className={classes.avatar} />

          <Typography variant='h6' style={{ marginTop: '10px',fontWeight:'bold',color:'black' }}>
           Reminder Sent Successfully
          </Typography>
          <Typography variant='body1' style={{ marginTop: '10px',color:'black' }}>
          Reminder has been sent to the Point of Contact <br/>
          to complete the pending deliverable
          </Typography>
          <DialogActions className={classes.dialogActions}>
            <Button
              variant='contained'
              color='primary'
              endIcon={<ChevronRight />}
              style={{
                borderRadius: '20px',
                textTransform: 'none',
              }}
              onClick={handleCloseRemind}
            >
              Ok
            </Button>
          </DialogActions>
          </>
        )}
        </DialogContent>
      </Dialog>
      )}

    </>
  );
};

export default PendingDashboard;
